import { isEqual } from 'lodash';
import type { ErrorDescription } from 'types/handled_error';
import { groupsHandledErrors } from './groupsHandledErrors';
import { labsHandledErrors } from './labsHandledErrors';
import { pharmaciesHandledErrors } from './pharmaciesHandledErrors';

const sharedHandledErrors: ErrorDescription[] = [
  {
    endpoint: 'roles',
    method: 'delete',
    responseStatus: 404,
  },
  {
    endpoint: 'user/update_password_after_reset',
    method: 'patch',
    responseStatus: 401,
    error: 'invalid_token',
  },
  {
    endpoint: /expired_products_requests\/[\d]*\/_generate_destruction_certificate/,
    method: 'post',
    responseStatus: 400,
    error: 'procedure_generation_failed',
  },
  // The public activation page renders its own screen for an invalid or expired code.
  {
    endpoint: /^secured\/pms\/pharmacy_activations\/[^/]+$/,
    method: 'get',
    responseStatus: 400,
    error: 'invalid_activation_code',
  },
  {
    endpoint: /^secured\/pms\/pharmacy_activations\/[^/]+$/,
    method: 'get',
    responseStatus: 400,
    error: 'expired_activation_code',
  },
];

const allHandledErrorsList = [
  ...sharedHandledErrors,
  ...groupsHandledErrors,
  ...pharmaciesHandledErrors,
  ...labsHandledErrors,
];

export const isHandled = (error: ErrorDescription): boolean =>
  !!allHandledErrorsList.find(
    (handledError: ErrorDescription) =>
      ((typeof handledError.endpoint === 'string' && handledError.endpoint === error.endpoint) ||
        (handledError.endpoint instanceof RegExp &&
          handledError.endpoint.test(error.endpoint as string))) &&
      handledError.method === error.method &&
      handledError.responseStatus === error.responseStatus &&
      isEqual(handledError.error, error.error)
  );
